import {cva} from 'class-variance-authority';

export const avatarVariants = cva(
  'relative flex justify-center items-center shrink-0 overflow-hidden rounded-full',
  {
    variants: {
      size: {
        small: 'h-8 w-8 border text-xs',
        default: 'h-10 w-10 border-2 text-sm',
        large: 'h-[52px] w-[52px] border-2 text-2xl font-urbanist font-medium',
        xlarge:
          'h-[120px] w-[120px] border-2 text-4xl font-urbanist font-medium',
      },
      color: {
        primary: 'border-primary-800 text-primary-800',
        secondary: 'border-secondary-700 text-secondary-700',
        tertiary: 'border-accent-800 text-accent-800',
      },
    },
    defaultVariants: {
      size: 'default',
      color: 'primary',
    },
  }
);
